import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AlignVerticalCenterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"align_vertical_center"}/>
}
